export default __webpack_public_path__ + "static/media/close_eye.f6851c1d.svg";